import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import history from 'app/routes/history';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  organisationSubscriptionSchema,
  organisationSubscriptionListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/organisationSubscriptions/actions';
import { OrganisationSubscriptionsActionTypes as types } from 'app/ducks/organisationSubscriptions/types';
import { getOrganisation } from 'app/ducks/organisations/actions';

function* createOrganisationSubscriptionSaga(action): any {
  yield put(sagaActions.createOrganisationSubscriptionPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationSubscriptions.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, organisationSubscriptionSchema);
    history.push('/billing');
    yield put(sagaActions.createOrganisationSubscriptionSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createOrganisationSubscriptionFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateOrganisationSubscriptionSaga(action): any {
  yield put(sagaActions.updateOrganisationSubscriptionPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationSubscriptions.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, organisationSubscriptionSchema);

    yield put(sagaActions.updateOrganisationSubscriptionSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateOrganisationSubscriptionFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getOrganisationSubscriptionSaga(action): any {
  yield put(sagaActions.getOrganisationSubscriptionPending());

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationSubscriptions.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, organisationSubscriptionSchema);
    yield put(sagaActions.getOrganisationSubscriptionSuccess(normalizedResponse));
    return normalizedResponse.entities.organisationSubscriptions[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getOrganisationSubscriptionFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllOrganisationSubscriptionsSaga(action): any {
  yield put(
    sagaActions.getAllOrganisationSubscriptionsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());
  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.organisationSubscriptions.pagination),
    )
    : action.payload.pagination;
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).organisationSubscriptions.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(
      response,
      organisationSubscriptionListSchema,
    );

    yield put(
      sagaActions.getAllOrganisationSubscriptionsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllOrganisationSubscriptionsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createOrganisationSubscriptionSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_ORGANISATION_SUBSCRIPTION_REQUESTED,
    createOrganisationSubscriptionSaga,
  );
}

function* updateOrganisationSubscriptionSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_ORGANISATION_SUBSCRIPTION_REQUESTED,
    updateOrganisationSubscriptionSaga,
  );
}

function* getOrganisationSubscriptionSagaWatcher(): any {
  yield takeLatest(
    types.GET_ORGANISATION_SUBSCRIPTION_REQUESTED,
    getOrganisationSubscriptionSaga,
  );
}

function* getAllOrganisationSubscriptionsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_ORGANISATION_SUBSCRIPTIONS_REQUESTED,
    getAllOrganisationSubscriptionsSaga,
  );
}

export default function* root(): any {
  yield all([
    createOrganisationSubscriptionSagaWatcher(),
    updateOrganisationSubscriptionSagaWatcher(),
    getOrganisationSubscriptionSagaWatcher(),
    getAllOrganisationSubscriptionsSagaWatcher(),
  ]);
}
